import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		deviceType: "pc"
	},
	mutations: {
		setStoreFun(state, res) {
			switch (res.stateName){
				case 'deviceType': 
					state.deviceType = res.stateValue;
					break;
			}
		}
	},getters:{
		getDeviceTypeFun (state){
			return state.deviceType;
		}
	},
	actions: {},
	modules: {}
})
